import React, { useState } from 'react'
import styled from 'styled-components';

import { Input, Button } from '../common';

const NewCategoryWrapper = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    width: 50%;
    grid-gap: 15px;
`

export const NewCategoryPanel = ({onAdd}) => {
    
    const [newCategoryName, setNewCategoryName] = useState()

    const handleClick = () => {
        onAdd(newCategoryName)
    }

    return (
        <NewCategoryWrapper>
            <Input placeholder="Nome da nova categoria" value={newCategoryName} onChange={setNewCategoryName} />
            <Button className="primary" onClick={handleClick}>Adicionar categoria</Button>
        </NewCategoryWrapper>
    )
}